export default __webpack_public_path__ + "static/media/boy2.c09103ce.svg";